export default {
    instance: undefined,
    content: undefined
}